<script>
export default {
  name: "CartButton",

  props: {
    as: {
      type: String,
      default: "button"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'button'
    }
  }
}
</script>

<template>
  <button v-if="as === 'button'" :type="type"
          :disabled="disabled ? true : null"
          class="w-auto my-6 text-white font-semibold text-base py-2 md:py-4 px-4 md:px-8 rounded-[80px] text-center inline-flex self-center"
          :class="[
              disabled ? 'bg-hurst-dark-gray opacity-50'
              : 'bg-gradient-to-br from-[#ffa807] to-[#EE5914] hover:from-[#EE5914] hover:to-[#ffa807] transition-all duration-500 ease-in-out bg-size-200 bg-pos-0 hover:bg-pos-100'
          ]"
  >
    <slot></slot>
  </button>
  <a v-else-if="as === 'a'"
          class="w-auto my-6 text-white font-semibold text-base py-2 md:py-4 px-4 md:px-8 rounded-[80px] text-center inline-flex self-center bg-gradient-to-br from-[#ffa807] to-[#EE5914] hover:from-[#EE5914] hover:to-[#ffa807] transition-all duration-500 ease-in-out bg-size-200 bg-pos-0 hover:bg-pos-100"
  >
    <slot></slot>
  </a>
</template>

<style scoped>

</style>